import $ from 'jquery';
let quiz = [
  {},
  {
    no:1,
    title:"農業従事者の平均年齢は、「平成」の30年間にどうなったでしょうか。",
    choice:["約10歳上がった","3〜4歳の上下を続けている","約10歳若返った"],
    answer:1
  },
  {
    no:2,
    title:"2019年度の日本の農林水産関係被害額はどのくらいでしょうか？",
    choice:["約1,500億円","約3,000億円","約4,800億円"],
    answer:3
  },
  {
    no:3,
    title:"2015年から比べて、2030年に世界全体で人口はどのくらい増えると予想されているでしょうか？",
    choice:["約3.5億人","約5.5億人","約11.5億人"],
    answer:3
  },
  {
    no:4,
    title:"2019年の日本の農産物の輸入額はどのくらいでしょうか。",
    choice:["約2.7兆円","約6.5兆円","約20兆円"],
    answer:2
  },
  {
    no:5,
    title:"農業の多面的機能に該当しないものはどれでしょうか。",
    choice:["土砂崩れを防ぐ","多様な生き物のすみかになる","川の流れを加速させる"],
    answer:3
  },
  {
    no:6,
    title:"わたしたちの国で食料輸入により排出される年間のCO<sub>2</sub>は、CO<sub>2</sub>排出係数で推計することができます。その量は約1,690万トン。これを国民一人当たりにすると約130kgです。ではこの130kgのCO<sub>2</sub>排出量は普段の生活に置き換えると、次のどれに当てはまるでしょうか。<br/><small>（資源エネルギー庁　家庭の省エネ徹底ガイド　春夏秋冬　から）</small>",
    choice:["夏の冷房温度設定を<br class='sp'/>27°Cから28°Cにするのを約7.5年分","1週間テレビを見ない","10年間お風呂に入らない"],
    answer:1
  },
  {
    no:7,
    title:"コロナ禍でイベント等が中止・延期になった2020年３～６月（緊急事態宣言時）に、切り花の価格は平均からどれくらい下がったでしょうか。 ",
    choice:["4割","2割","1割"],
    answer:1
  }
];
let quizNo = 1;
let choiceNo = 1;
let choiceAns = 1;

// 第X回ごとにクイズ読み込み
export function loadQuizAll(pNo) {

  console.log(pNo);
  quizNo = pNo;

  if(pNo == 5){
    choiceNo = 5;
  }


  loadQuiz(choiceNo);
}

$(".pageQuiz_quesSwitchNo").on("click", function() {

  if( $(this).data("no") != choiceNo ){
    ++choiceNo;
  }
  loadQuiz(choiceNo);
});

$(".pageQuiz_quesBtn").on("click", function() {

  // 選択肢のスタイル変更
  $(".pageQuiz_quesBtn").removeClass("active");
  $(this).addClass("active");

  // 回答ボタンのスタイル変更
  $(".pageQuiz_quesSwitchAns").addClass("active");

  // 選択の保持
  choiceAns = $(this).data("no");
});

// 選択後・回答
$(".pageQuiz_quesSwitchAns").on("click", function() {

  // 選択肢未チョイス
  if( !$(this).hasClass("active") ){
    return;
  }
  // console.log(choiceNo);

  //問題文の非表示
  $(".pageQuiz_quesContainer").hide();

  // 正解
  if(quiz[choiceNo].answer == choiceAns){
    $(".pageQuiz_correctContainer[data-no='" + choiceNo + "']").fadeIn(300);
    $(".pageQuiz_missContainer").hide();

    $(".pageQuiz_quesSwitchAns").removeClass("active");

    // 全問回答済みであれば結果を表示

    if ($("body").data("no") == "01") {
      if( choiceNo == 4 ){
        $(".rsltWrap").fadeIn(300);
        $(".pageQuiz_correctContainer .pageQuiz_quesSwitchWrap").hide();
      }
    }else{
      if( choiceNo == 7 ){
        $(".rsltWrap").fadeIn(300);
        $(".pageQuiz_correctContainer .pageQuiz_quesSwitchWrap").hide();
      }
    }

  }else{
  // 不正解
  $(".pageQuiz_correctContainer").hide();
    $(".pageQuiz_missContainer[data-no='" + choiceNo + "']").fadeIn(300);
  }

  $('body,html').scrollTop(0);
});

//設問ごとにクイズ読み込み
function loadQuiz(pChoice) {

  console.log("問題を読み込み中・・・問題：" + pChoice + "を選択");

  // 問題文・正解セクション・誤答セクション全部隠す
  $(".pageQuiz_quesContainer, .pageQuiz_correctContainer, .pageQuiz_missContainer").hide();
  $(".pageQuiz_quesContainer[data-no='" + pChoice + "']").fadeIn(300);

  // タイトルをロード
  $(".pageQuiz_title_img").attr("src", "/ads/nogizaka46ja2020/img/quiz/title_0" + pChoice + ".png");

  // 問題文をロード
  $(".pageQuiz_quesText").html("<span>" + quiz[pChoice].title + "</span>");

  // ボタンのactiveを削除
  $(".pageQuiz_quesSwitch .pageQuiz_quesSwitchAns").removeClass("active");

  // 選択肢をロード
  $(".pageQuiz_quesBtn[data-no='1']").html("<span>" + quiz[pChoice].choice[0] + "</span>");
  $(".pageQuiz_quesBtn[data-no='2']").html("<span>" + quiz[pChoice].choice[1] + "</span>");
  $(".pageQuiz_quesBtn[data-no='3']").html("<span>" + quiz[pChoice].choice[2] + "</span>");

  // 付随するイメージ画像をロード
  // $(".pageQuiz_image-3").attr("src", "/ads/nogizaka46ja/img/quiz/0" + pChoice + "/image_03.png");
  // $(".pageQuiz_image-correct").attr("src", "/ads/nogizaka46ja/img/quiz/0" + pChoice + "/correct.jpg");

  // 正解の選択肢をロード
  $(".pageQuiz_answer").html(quiz[pChoice].choice[quiz[pChoice].answer-1]);

  // $(".quiz_box_title").html(quiz[pChoice].title);
  // $(".quiz_Nolist#quiz_Nolist-" + quiz[pChoice].no).addClass("active");

  //  choiceNo++;
  $('body,html').scrollTop(0);
}